export const KVAGZuschuss = [
  {
    'PAISY Wert': '',
    Bezeichnung: 'entfällt',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'BBG',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'Entgelt',
  },
  {
    'PAISY Wert': 8,
    Bezeichnung: 'Vorgabe',
  },
  {
    'PAISY Wert': 9,
    Bezeichnung: 'Kein AG Zuschuss',
  },
];
